module.exports = __webpack_public_path__ + "img/time-over.56737e0c.svg";